import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { Icon } from "@iconify/react";
import SwitchDarkMode from "../Switchmode";
import { useEffect, useState } from "react";
import { PublicKey, Transaction } from "@solana/web3.js";
import React from "react";
import { useAuth } from "../firebase";

type DisplayEncoding = "utf8" | "hex";
type PhantomEvent = "disconnect" | "connect" | "accountChanged";
type PhantomRequestMethod =
  | "connect"
  | "disconnect"
  | "signTransaction"
  | "signAllTransactions"
  | "signMessage";

interface ConnectOpts {
  onlyIfTrusted: boolean;
}

interface PhantomProvider {
  publicKey: PublicKey | null;
  isConnected: boolean | null;
  signTransaction: (transaction: Transaction) => Promise<Transaction>;
  signAllTransactions: (transactions: Transaction[]) => Promise<Transaction[]>;
  signMessage: (
    message: Uint8Array | string,
    display?: DisplayEncoding
  ) => Promise<any>;
  connect: (opts?: Partial<ConnectOpts>) => Promise<{ publicKey: PublicKey }>;
  disconnect: () => Promise<void>;
  on: (event: PhantomEvent, handler: (args: any) => void) => void;
  request: (method: PhantomRequestMethod, params: any) => Promise<unknown>;
}

const Header = () => {
  const currentUser : any =useAuth();
  const [provider, setProvider] = useState<PhantomProvider | undefined>(
    undefined
  );
  const [walletKey, setWalletKey] = useState<PhantomProvider | undefined>(
    undefined
  );

  /**
   * @description gets Phantom provider, if it exists
   */
  const getProvider = (): PhantomProvider | undefined => {
    if ("solana" in window) {
      // @ts-ignore
      const provider = window.solana as any;
      if (provider.isPhantom) return provider as PhantomProvider;
    }
  };

  /**
   * @description prompts user to connect wallet if it exists
   */
  const connectWallet = async () => {
    // @ts-ignore
    const { solana } = window;

    if (solana) {
      try {
        const response = await solana.connect();
        console.log("wallet account ", response.publicKey.toString());
        setWalletKey(response.publicKey.toString());
      } catch (err) {
        // { code: 4001, message: 'User rejected the request.' }
      }
    }
  };
  const walletListner = async () => {
    // console.log(window.solana);
    
    // @ts-ignore
    const { solana } = window;
    
    

    if (solana) {
      try {
        const response = await solana.connect();
        // console.log("wallet account ", response.publicKey.toString());
        console.log(response.publicKey.toString());
        
        setWalletKey(response.publicKey.toString());
      } catch (err) {
        // { code: 4001, message: 'User rejected the request.' }
      }
    }
  };

  

  /**
   * @description disconnect Phantom wallet
   */
  const disconnectWallet = async () => {
    // @ts-ignore
    const { solana } = window;

    if (walletKey && solana) {
      await (solana as PhantomProvider).disconnect();
      setWalletKey(undefined);
    }
  };

  // detect phantom provider exists
  useEffect(() => {
    // console.log(walletKey);
    walletListner()
    window.scrollTo(0, 0);
    const provider = getProvider();
    if (provider) setProvider(provider);
    else setProvider(undefined);
  }, []);
 

  return (
    <header className="header-main">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-sm-3">
            <div className="d-flex align-items-center justify-content-between">
              <Link to="/" className="dark-logo-link">
                <img
                  className="logo-main logo-dark"
                  src="../../../assets/images/logo-dark-h.webp"
                />
              </Link>
              <Link to="/" className="light-logo-link">
                <img
                  className="logo-main logo-light"
                  src="../../../assets/images/logo-light-h.webp"
                  alt=""
                />
              </Link>
              {/* <img
                className="off-canvas"
                src="../../../assets/images/icons/offcanvas.png"
              /> */}
            </div>
          </div>
          <div className="col-sm-4">
            <div className="d-flex align-items-center">
              <img
                className="search-ico"
                src="../../../assets/images/icons/search.png"
              />
              <input
                className="search-header-main"
                placeholder="Type here"
                type="text"
              />
            </div>
          </div>

          <div className="col-sm-5">
            <div className="nav-right-side ">
              <div className="nav-wraping">
                <Navbar bg="transparent" expand="lg">
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                      <div className="home-rank-coll">
                        <Link to="/" className="active nav-single-link">
                          Home
                        </Link>
                        {/* <Nav.Link className="nav-single-link" href="#"> */}
                        <Link className="nav-single-link" to="/ranking">
                          Ranking
                        </Link>
                        {/* </Nav.Link> */}
                        <Link className="nav-single-link" to="/nftcollection">
                          Collections
                        </Link>
                        <NavDropdown title="Create" id="create-dropdown">
                          <NavDropdown.Divider />
                          <NavDropdown.Item >
                            <Link className="dropdown-item" to="/shopcreate">Create Shop</Link>
                          </NavDropdown.Item>
                          <NavDropdown.Divider />
                          <NavDropdown.Item>
                         <Link className="dropdown-item" to="/physicalitem">   Create Physical Item</Link>
                          </NavDropdown.Item>
                          <NavDropdown.Divider />
                          <NavDropdown.Item >
                          
                            <Link className="dropdown-item" to="/digitalitem">  Create Digital Item</Link>
                          </NavDropdown.Item>
                        </NavDropdown>
                      </div>

                      <div className=" connect-wallet-area">
                        <div className="connect-wallet-wrapping">

                        {provider && !walletKey && (
                          <button className="connect-wallet-btn"  onClick={connectWallet}>
                            Connect Wallet
                          </button>)}



                          {provider && walletKey && (<button className="connect-wallet-btn"  onClick={disconnectWallet}>
                         
                          {String(walletKey).substring(0, 6) +
                        "..." +
                        String(walletKey).substring(38)}
                         
                          </button>)}
                          {!provider && (
                            <button className="connect-wallet-btn">
                            <a className="install-phantom" href="https://phantom.app/">install phantom</a>
                            </button>
                          )}



                        </div>
                        <div className="login-cart-wta d-flex align-items-center">
                          <Icon icon="solana-logo@logotyp.us" />
                          <Dropdown align="end" className="drop-account">
                            <Dropdown.Toggle>
                              <img
                                className="login-ico"
                                src="../../../assets/images/icons/person.png"
                              />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="drop-menu ">
                              <Dropdown.Item className="drop-wrapp">
                                <img
                                  className="img-fluid"
                                  src="../../../assets/images/icons/solona.png"
                                />
                                <span className="first"> SOL:</span>{" "}
                                <span>37.31</span>
                              </Dropdown.Item>

                              <Dropdown.Item className="drop-wrapp">
                                <img
                                  className="img-fluid"
                                  src="../../../assets/images/icons/dust.png"
                                />
                                <span className="first"> Dust:</span>{" "}
                                <span>37.31</span>
                              </Dropdown.Item>

                              <Dropdown.Item className="drop-wrapp last">
                                <img
                                  className="img-fluid"
                                  src="../../../assets/images/icons/usdc.png"
                                />
                                <span className="first"> USDC:</span>{" "}
                                <span>37.31</span>
                              </Dropdown.Item>
                              <div className="spacciog"></div>
                              <div className="all-ico-tit-wrapp">
                               {
                               currentUser && currentUser?.displayName ? (
                             <>
                             <h6>Loggen in as: { currentUser?.displayName}</h6>
                             </>
                                ):( <>
                                  <Link
                                  to="/login"
                                  style={{ color: "transparent" }}
                                >
                                  <div className="drop-wrap-ico-tit">
                                    <Icon icon="oi:account-login" />
                                    <span> Login </span>
                                  </div>
                                </Link>

                                <Link
                                  to="/signup"
                                  style={{ color: "transparent" }}
                                >
                                  <div className="drop-wrap-ico-tit">
                                    <Icon icon="ic:round-app-registration" />
                                    <span> Sign up </span>
                                  </div>
                                </Link>
                                </>
                                )
                               }

                                <div className="drop-wrap-ico-tit">
                                  <Icon icon="bi:box-fill" />
                                  <span> Orders</span>
                                </div>

                                <Link
                                  to="/account"
                                  style={{ color: "transparent" }}
                                >
                                  <div className="drop-wrap-ico-tit">
                                    <Icon icon="ant-design:setting-filled" />
                                    <span> Profile Setting </span>
                                  </div>
                                </Link>
                                <div className="drop-wrap-ico-tit">
                                  <Icon icon="ic:baseline-sell" />
                                  <span>Sell </span>
                                </div>

                                <div className="drop-wrap-ico-tit">
                                  <Icon icon="humbleicons:activity" />
                                  <span> Activites</span>
                                </div>

                                <div className="drop-wrap-ico-tit">
                                  <Icon icon="akar-icons:sign-out" />
                                  <span> Signout</span>
                                </div>
                              </div>
                            </Dropdown.Menu>
                          </Dropdown>
                          <Link to="/cart">
                            <img
                              className="cart-ico"
                              src="../../../assets/images/icons/cart.png"
                            />
                          </Link>
                        </div>

                        <div>
                          <SwitchDarkMode />
                        </div>
                      </div>
                    </Nav>
                  </Navbar.Collapse>
                </Navbar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header;
